import { render, staticRenderFns } from "./akv-layout.vue?vue&type=template&id=03570afe"
import script from "./akv-layout.vue?vue&type=script&lang=js"
export * from "./akv-layout.vue?vue&type=script&lang=js"
import style0 from "./akv-layout.vue?vue&type=style&index=0&id=03570afe&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports